<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  name: 'App',
  created () {
    if (this.deviceType === 'weixin') {
      // 微信注册微信信息
      this.wxConfig()
    }
  },
  mounted () {
    const timer = setTimeout(function () {
      timer && clearTimeout(timer)
      const titleText = document.querySelector('title').innerText
      if (window.CHENORMAL || window.CHESPEED) {
        window.callNativeMethod('onChangeWebTitle', {
          changeWebTitle: titleText
        })
      }
    }, 500)
  }
}
</script>
<style lang="less">
@import "./mixin/public.css";
</style>
